import type { Action } from "../../actions/types";

export type StoreState = number;

export const initialState = 0;

export function reducer(
  state: StoreState = initialState,
  action: Action
): number {
  if (action.type === "GET_SHARE_COUNT_SUCCESS") {
    return action.response.data.shareCount;
  }

  return state;
}
